import { onCleanup } from 'solid-js';
import { createReconciledStore } from './reconciledStore';
export function usePresenter(PresenterClass) {
    const [model, setModel] = createReconciledStore({ value: undefined });
    const presenter = new PresenterClass();
    const updateModel = (newModel) => {
        setModel({ value: newModel });
    };
    presenter.subscribe(updateModel);
    onCleanup(() => {
        presenter.unsubscribe(updateModel);
        presenter.destroy();
    });
    return { model: () => model.value };
}
